// import ModalForm from "./Form";
import ClassTrialSkillsTableForm from "./ClassTrialSkillsTableForm";
import {
	PLACEMENT_SKILL,
	DATATABLE_EXPORT,
} from "../../../../../../../Config/ApiUrl";
import * as actions from "../../../../../../../Config/ApiUrl";

export const ClassTrialSkillsTableSchema = {
	components: { ClassTrialSkillsTableForm },

	data() {
		return {
			DATATABLE_EXPORT,
			isAddEditModalActive: false,
			deleteConfirmationModalActive: false,
			deleteLoader: false,
			selectedUrl: this.ENDPOINT,
			Endpoint: PLACEMENT_SKILL + "?placement_id=" + this.placementId,
			tableId: "class-trial-skills-table",
			formId: "class-trial-skills-table-form",
			rowData: {},
			tableColumns: [
				{
					title: "Skills",
					type: "text",
					key: "skill",
				},
				{
					title: "Score",
					type: "custom-html",
					key: "score_1",
					isVisible: true,
					modifier: (value) => {
						let html = "";
						let star = "";
						let maxStar = 5;
						let score = value;
						let emptyStarCount = maxStar - score;

						for (let i = 0; i < score; i++) {
							star += `<i class="fas fa-star text-warning"></i>`;
						}

						for (let i = 0; i < emptyStarCount; i++) {
							star += `<i class="far fa-star text-warning"></i>`;
						}

						html = `<div>${star}</div>`;
						return html;
					},
				},
				// {
				// 	title: "普",
				// 	type: "custom-html",
				// 	key: "score_2",
				// 	modifier: (value) => {
				// 		let html = "";
				// 		let star = "";
				// 		let maxStar = 5;
				// 		let maxAge = 100;
				// 		let age = value;
				// 		let starCount = Math.ceil(age / 20);
				// 		let emptyStarCount = maxStar - starCount;

				// 		for (let i = 0; i < starCount; i++) {
				// 			star += `<i class="fas fa-star text-warning"></i>`;
				// 		}

				// 		for (let i = 0; i < emptyStarCount; i++) {
				// 			star += `<i class="far fa-star text-warning"></i>`;
				// 		}

				// 		html = `<div class="d-flex justify-content-center">${star}</div>`;
				// 		return html;
				// 	},
				// },
				// {
				// 	title: "差",
				// 	type: "custom-html",
				// 	key: "score_3",
				// 	modifier: (value) => {
				// 		let html = "";
				// 		let star = "";
				// 		let maxStar = 5;
				// 		let maxAge = 100;
				// 		let age = value;
				// 		let starCount = Math.ceil(age / 20);
				// 		let emptyStarCount = maxStar - starCount;

				// 		for (let i = 0; i < starCount; i++) {
				// 			star += `<i class="fas fa-star text-warning"></i>`;
				// 		}

				// 		for (let i = 0; i < emptyStarCount; i++) {
				// 			star += `<i class="far fa-star text-warning"></i>`;
				// 		}

				// 		html = `<div class="d-flex justify-content-center">${star}</div>`;
				// 		return html;
				// 	},
				// },
				// {
				// 	title: "无",
				// 	type: "custom-html",
				// 	key: "score_4",
				// 	modifier: (value) => {
				// 		let html = "";
				// 		let star = "";
				// 		let maxStar = 5;
				// 		let maxAge = 100;
				// 		let age = value;
				// 		let starCount = Math.ceil(age / 20);
				// 		let emptyStarCount = maxStar - starCount;

				// 		for (let i = 0; i < starCount; i++) {
				// 			star += `<i class="fas fa-star text-warning"></i>`;
				// 		}

				// 		for (let i = 0; i < emptyStarCount; i++) {
				// 			star += `<i class="far fa-star text-warning"></i>`;
				// 		}

				// 		html = `<div class="d-flex justify-content-center">${star}</div>`;
				// 		return html;
				// 	},
				// },
				// {
				// 	title: "未",
				// 	type: "custom-html",
				// 	key: "score_5",
				// 	modifier: (value) => {
				// 		let html = "";
				// 		let star = "";
				// 		let maxStar = 5;
				// 		let maxAge = 100;
				// 		let age = value;
				// 		let starCount = Math.ceil(age / 20);
				// 		let emptyStarCount = maxStar - starCount;

				// 		for (let i = 0; i < starCount; i++) {
				// 			star += `<i class="fas fa-star text-warning"></i>`;
				// 		}

				// 		for (let i = 0; i < emptyStarCount; i++) {
				// 			star += `<i class="far fa-star text-warning"></i>`;
				// 		}

				// 		html = `<div class="d-flex justify-content-center">${star}</div>`;
				// 		return html;
				// 	},
				// },
			],
			actionObj: {
				title: this.$t("action"),
				type: "action",
			},
			options: {
				name: "ClassTrialSkillsTable",
				url: PLACEMENT_SKILL + "?placement_id=" + this.placementId,
				showHeader: true,
				enableHighlights: false,
				enableRowSelect: false,
				enableSaveFilter: false,
				columns: [],
				actions: [
					{
						title: this.$t("edit"),
						icon: "edit",
						type: "none",
						component: "class-trial-skills-table-form",
						modalId: "class-trial-skills-table-form",
					},
				],
				showFilter: false,
				showSearch: false,
				showCount: false,
				showClearFilter: false,
				paginationType: "false",
				responsive: true,
				rowLimit: 4,
				showAction: true,
				orderBy: "desc",
				actionType: "default",
			},
		};
	},
	methods: {},
};
